import React, { CSSProperties, FunctionComponent } from 'react';
import { ReactComponent as Pencil } from '../../assets/icons/pencil.svg';
import { ReactComponent as MinusCircle } from '../../assets/icons/minus-circle.svg';
import { ReactComponent as ChevronUp } from '../../assets/icons/chevron-up.svg';
import { ReactComponent as ChevronDown } from '../../assets/icons/chevron-down.svg';
import { ReactComponent as CheckboxChecked } from '../../assets/icons/checkbox.svg';
import { ReactComponent as CheckboxIndeterminate } from '../../assets/icons/checkbox-indeterminate.svg';
import { ReactComponent as CheckboxUnchecked } from '../../assets/icons/checkbox-unchecked.svg';
import { ReactComponent as RadioChecked } from '../../assets/icons/radio.svg';
import { ReactComponent as RadioUnchecked } from '../../assets/icons/radio-unchecked.svg';
import { ReactComponent as Survey } from '../../assets/icons/survey.svg';
import { ReactComponent as Preview } from '../../assets/icons/preview.svg';
import { ReactComponent as ShieldCheck } from '../../assets/icons/shield-check.svg';
import { ReactComponent as MessageBubbleFirst } from '../../assets/icons/messages-bubble-first.svg';
import { ReactComponent as MessageBubbleSecond } from '../../assets/icons/messages-bubble-second.svg';
import { ReactComponent as Check } from '../../assets/icons/check.svg';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import { ReactComponent as Info } from '../../assets/icons/info.svg';
import { ReactComponent as Times } from '../../assets/icons/times.svg';
import { ReactComponent as Lock } from '../../assets/icons/lock.svg';
import { ReactComponent as ChevronDownBig } from '../../assets/icons/chevron-down-big.svg';
import { ReactComponent as Exchange } from '../../assets/icons/exchange.svg';
import { ReactComponent as Gear } from '../../assets/icons/gear.svg';
import { ReactComponent as Archive } from '../../assets/icons/archive.svg';
import { ReactComponent as Chart } from '../../assets/icons/chart.svg';
import { ReactComponent as Merge } from '../../assets/icons/merge.svg';
import { ReactComponent as Reminder } from '../../assets/icons/reminder.svg';
import { ReactComponent as UserChange } from '../../assets/icons/userChange.svg';
import { ReactComponent as UserPlus } from '../../assets/icons/userPlus.svg';
import { ReactComponent as InactiveStar } from '../../assets/icons/star.svg';
import { ReactComponent as ActiveStar } from '../../assets/icons/activeStar.svg';
import { ReactComponent as Unarchive } from '../../assets/icons/unarchive.svg';
import { ReactComponent as Logo } from '../../assets/images/logo.svg';
import { ReactComponent as Filter } from '../../assets/icons/filter.svg';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import { ReactComponent as Candidates } from '../../assets/icons/candidates.svg';
import { ReactComponent as Position } from '../../assets/icons/position.svg';
import { ReactComponent as ChangeRole } from '../../assets/icons/change-role.svg';
import { ReactComponent as Email } from '../../assets/icons/email.svg';
import { ReactComponent as Phone } from '../../assets/icons/phone.svg';
import { ReactComponent as User } from '../../assets/icons/user.svg';
import { ReactComponent as Prospects } from '../../assets/icons/prospects.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg';
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left.svg';
import { ReactComponent as More } from '../../assets/icons/more.svg';
import { ReactComponent as PaperPlane } from '../../assets/icons/paper-plane.svg';
import { ReactComponent as Twitter } from '../../assets/icons/twitter.svg';
import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg';
import { ReactComponent as Linkedin } from '../../assets/icons/linkedin.svg';
import { ReactComponent as CheckCircle } from '../../assets/icons/check-circle.svg';
import { ReactComponent as DownloadCircle } from '../../assets/icons/download-circle.svg';
import { ReactComponent as Caution } from '../../assets/icons/caution.svg';
import { ReactComponent as Drag } from '../../assets/icons/drag.svg';
import { ReactComponent as Bell } from '../../assets/icons/bell.svg';
import { ReactComponent as Exclamation } from '../../assets/icons/exclamation.svg';
import { ReactComponent as KodiakLogo } from '../../assets/images/kodiak-logo.svg';
import { ReactComponent as Link } from '../../assets/icons/link.svg';
import { ReactComponent as Download } from '../../assets/icons/download.svg';
import { ReactComponent as Sort } from '../../assets/icons/sort.svg';
import { ReactComponent as QuestionCircle } from '../../assets/icons/question-circle.svg';

export type IconType = 'pencil' |
'minusCircle' |
'chevronUp' |
'chevronDown' |
'checkboxChecked' |
'checkboxIndeterminate' |
'checkboxUnchecked' |
'radioChecked' |
'radioUnchecked' |
'survey' |
'preview' |
'shieldCheck' |
'messageBubbleFirst' |
'check' |
'warning' |
'plus' |
'info' |
'times' |
'lock' |
'chevronDownBig' |
'exchange' |
'gear' |
'filter'|
'archive' |
'chart' |
'merge' |
'reminder' |
'userChange' |
'userPlus' |
'inactiveStar' |
'activeStar' |
'unarchive' |
'logo' |
'filter' |
'close' |
'survey' |
'candidates' |
'position' |
'plus' |
'changeRole' |
'email' |
'phone' |
'user' |
'prospects' |
'arrowRight' |
'arrowLeft' |
'more' |
'paperPlane' |
'twitter' |
'facebook' |
'linkedin' |
'checkCircle' |
'downloadCircle' |
'caution' |
'drag' |
'messageBubbleSecond' |
'bell' |
'exclamation' |
'kodiakLogo' |
'link' |
'download' |
'sort' |
'questionCircle';

interface IProps {
  icon: IconType;
  className?: string;
  style?: CSSProperties;
}

const Icon: FunctionComponent<IProps> = ({ icon, ...rest }) => {
  switch (icon) {
    case 'pencil': return <Pencil {...rest} />;
    case 'minusCircle': return <MinusCircle {...rest} />;
    case 'gear': return <Gear {...rest} />;
    case 'chevronUp': return <ChevronUp {...rest} />;
    case 'chevronDown': return <ChevronDown {...rest} />;
    case 'checkboxChecked': return <CheckboxChecked {...rest} />;
    case 'checkboxIndeterminate': return <CheckboxIndeterminate {...rest} />;
    case 'checkboxUnchecked': return <CheckboxUnchecked {...rest} />;
    case 'radioChecked': return <RadioChecked {...rest} />;
    case 'radioUnchecked': return <RadioUnchecked {...rest} />;
    case 'survey': return <Survey {...rest} />;
    case 'preview': return <Preview {...rest} />;
    case 'shieldCheck': return <ShieldCheck {...rest} />;
    case 'messageBubbleFirst': return <MessageBubbleFirst {...rest} />;
    case 'check': return <Check {...rest} />;
    case 'warning': return <Warning {...rest} />;
    case 'info': return <Info {...rest} />;
    case 'times': return <Times {...rest} />;
    case 'lock': return <Lock {...rest} />;
    case 'chevronDownBig': return <ChevronDownBig {...rest} />;
    case 'exchange': return <Exchange {...rest} />;
    case 'filter': return <Filter {...rest} />;
    case 'archive': return <Archive {...rest} />;
    case 'unarchive': return <Unarchive {...rest} />;
    case 'chart': return <Chart {...rest} />;
    case 'merge': return <Merge {...rest} />;
    case 'reminder': return <Reminder {...rest} />;
    case 'userChange': return <UserChange {...rest} />;
    case 'userPlus': return <UserPlus {...rest} />;
    case 'inactiveStar': return <InactiveStar {...rest} />;
    case 'activeStar': return <ActiveStar {...rest} />;
    case 'logo': return <Logo {...rest} />;
    case 'close': return <Close {...rest} />;
    case 'position': return <Position {...rest} />;
    case 'candidates': return <Candidates {...rest} />;
    case 'email': return <Email {...rest} />;
    case 'plus': return <Plus {...rest} />;
    case 'changeRole': return <ChangeRole {...rest} />;
    case 'phone': return <Phone {...rest} />;
    case 'user': return <User {...rest} />;
    case 'prospects': return <Prospects {...rest} />;
    case 'arrowRight': return <ArrowRight {...rest} />;
    case 'arrowLeft': return <ArrowLeft {...rest} />;
    case 'more': return <More {...rest} />;
    case 'paperPlane': return <PaperPlane {...rest} />;
    case 'twitter': return <Twitter {...rest} />;
    case 'facebook': return <Facebook {...rest} />;
    case 'linkedin': return <Linkedin {...rest} />;
    case 'checkCircle': return <CheckCircle {...rest} />;
    case 'downloadCircle': return <DownloadCircle {...rest} />;
    case 'caution': return <Caution {...rest} />;
    case 'drag': return <Drag {...rest} />;
    case 'messageBubbleSecond': return <MessageBubbleSecond {...rest} />;
    case 'bell': return <Bell {...rest} />;
    case 'exclamation': return <Exclamation {...rest} />;
    case 'kodiakLogo': return <KodiakLogo {...rest} />;
    case 'link': return <Link {...rest} />;
    case 'download': return <Download {...rest} />;
    case 'sort': return <Sort {...rest} />;
    case 'questionCircle': return <QuestionCircle {...rest} />;

    default: return null;
  }
};

export default Icon;
